// jQuery 4 ESM compatibility wrapper
// jQuery 4 is ESM ("type": "module"), so require() returns a namespace object {default, $, jQuery}
// instead of the jQuery function. AMD/CJS libraries (select2, datatables, jqtree) expect require('jquery')
// to return the function directly. This wrapper re-exports the default as module.exports.
const jqModule = require("../../node_modules/jquery/dist-module/jquery.module.js");
const jQuery = jqModule.default || jqModule;

// Polyfills for APIs removed in jQuery 4, still used by legacy plugins
// (bootstrap-datepicker, select2, jqtree, datatables)
jQuery.isArray ??= Array.isArray;
jQuery.isFunction ??= (fn) => typeof fn === 'function';
jQuery.isNumeric ??= (n) => !isNaN(parseFloat(n)) && isFinite(n);
jQuery.trim ??= (str) => str == null ? '' : str.trim();
jQuery.proxy ??= (fn, context) => fn.bind(context);
jQuery.camelCase ??= (str) => str.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
jQuery.type ??= (obj) => {
    if (obj == null) return obj + '';
    const type = typeof obj;
    if (type === 'object' || type === 'function') {
        return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
    }
    return type;
};
jQuery.unique ??= jQuery.uniqueSort;

module.exports = jQuery;
